import type { SVGProps } from "react";

export const GoogleContacts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 423.077 500"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Contacts</title>{" "}
    <path
      d="M160.256,243.59C71.667,243.59,0,315.256,0,403.846v67.308C0,487.083,12.917,500,28.846,500h76.923 l76.923-256.41H160.256z"
      fill="#86A9FF"
    />{" "}
    <path
      d="M423.077,349.359c0-58.462-47.308-105.769-105.769-105.769h-76.923V500h76.923 c58.462,0,105.769-47.308,105.769-105.769"
      fill="#578CFF"
    />{" "}
    <path
      d="M76.923,349.359c0-58.462,47.308-105.769,105.769-105.769h57.692c58.462,0,105.769,47.308,105.769,105.769 v44.872c0,58.462-47.308,105.769-105.769,105.769H105.769c-15.929,0-28.846-12.917-28.846-28.846V349.359z"
      fill="#0057CC"
    />{" "}
    <circle cx="211.538" cy="99.359" fill="#0057CC" r="99.359" />
  </svg>
);

export default GoogleContacts;
